import { Component } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'ms-my-bets-edited-badge',
    template: '<div class="my-bets-edited-badge">{{sitecore.myBets_Print.EditedPrintBadge}}</div>',
    standalone: false,
})
export class MyBetsEditedBadgeComponent {
    constructor(public sitecore: Sitecore) {}
}
